var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiLabelLeftPurplish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.902,
    height: 38,
    viewBox: "0 0 133.902 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UI_Label_left_purplish",
    d: "M5.085,25.035,0,36.555,132.79,38l.536-16.126L133.9,4.439,95.239,3.087.261,0Z",
    transform: "translate(0 0)",
    fill: "#666394"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiLabelLeftPurplish);
export default __webpack_public_path__ + "static/media/UI_Label_left_purplish.2e2bfcc0ec5ba4b472ed4365852981d3.svg";
export { ForwardRef as ReactComponent };